import { Helmet } from "react-helmet-async";

import { CONFIG } from "src/global-config";
import { clearChunkReloadState } from "src/utils/lazyRetry";

type AppErrorPageProps = {
  title?: string;
  message?: string;
};

const defaultTitle = `Something went wrong | ${CONFIG.appName}`;
const defaultMessage =
  "We hit a temporary issue while loading this page. Please refresh and try again.";

const AppErrorPage = ({
  title = defaultTitle,
  message = defaultMessage,
}: AppErrorPageProps) => {
  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "32px 20px",
          background:
            "radial-gradient(circle at top, rgba(134, 21, 40, 0.12), transparent 42%), #fff9f6",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "720px",
            borderRadius: "28px",
            padding: "48px 28px",
            backgroundColor: "#fffdfb",
            border: "1px solid rgba(134, 21, 40, 0.12)",
            boxShadow: "0 24px 60px rgba(134, 21, 40, 0.12)",
            textAlign: "center",
          }}
        >
          <div
            style={{
              margin: "0 auto 20px",
              width: "72px",
              height: "72px",
              borderRadius: "999px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#861528",
              color: "#fff",
              fontFamily: "'Poppins', sans-serif",
              fontSize: "28px",
              fontWeight: 700,
            }}
          >
            WM
          </div>

          <p
            style={{
              margin: 0,
              color: "#861528",
              fontFamily: "'Poppins', sans-serif",
              fontSize: "13px",
              fontWeight: 700,
              letterSpacing: "0.18em",
              textTransform: "uppercase",
            }}
          >
            WeMust
          </p>

          <h1
            style={{
              margin: "16px 0 12px",
              color: "#1f1720",
              fontFamily: '"YourCustomFont", serif',
              fontSize: "clamp(2.4rem, 4vw, 4rem)",
              lineHeight: 1,
              fontWeight: 400,
            }}
          >
            Something went wrong
          </h1>

          <p
            style={{
              margin: "0 auto",
              maxWidth: "520px",
              color: "#54464d",
              fontFamily: "'Poppins', sans-serif",
              fontSize: "16px",
              lineHeight: 1.7,
            }}
          >
            {message}
          </p>

          <button
            type="button"
            onClick={() => {
              clearChunkReloadState();
              window.location.reload();
            }}
            style={{
              marginTop: "28px",
              padding: "14px 32px",
              border: "none",
              borderRadius: "999px",
              backgroundColor: "#861528",
              color: "#fff",
              cursor: "pointer",
              fontFamily: "'Poppins', sans-serif",
              fontSize: "15px",
              fontWeight: 700,
              letterSpacing: "0.03em",
              textTransform: "uppercase",
              boxShadow: "0 14px 30px rgba(134, 21, 40, 0.24)",
            }}
          >
            Refresh Page
          </button>
        </div>
      </div>
    </>
  );
};

export default AppErrorPage;
